import React from 'react';
import WelcomePage from '../../Pages/WelcomePage';

const WelcomeContainer = () => {
  return <WelcomePage />;
};

export default WelcomeContainer;
